export const environment = {
  production: true,
  apiUrl: 'https://api.act4travel.greentripper.org/api',
  posthogKey: 'phc_N6mOIAO2B26VkVIHH4skKfbak72sGcY3MXS2lmqDhbg',
  posthogHost: 'https://eu.i.posthog.com',
  sentryDsn:
    'https://85ef7ad00aa04c39fedd83409d1cf66b@o4509163255365632.ingest.de.sentry.io/4509163259953232',
  onboardingVideoId: 'j6W6FwGBPdU', // YouTube video ID from https://www.youtube.com/watch?v=j6W6FwGBPdU
  /**
   * Build-time feature switches. Mirrors FEATURE_*_ENABLED on the API
   * (start/env.ts) — flip both sides together when a feature is released,
   * otherwise the UI calls a route that is not registered.
   */
  features: {
    /** Excel mass import in the trip creation modal. Still a POC. */
    excelImport: false,
  },
} as const;
